/**
 * Firmaer den aktuelle bruger må agere på vegne af:
 * SUPERADMIN → alle firmaer; SALESPERSON → egne tildelte firmaer.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase/client";
import { useAuth } from "@/features/auth/AuthContext";

export interface ImpersonatableCompany {
  id: string;
  name: string;
  status: string;
  cvr: string | null;
}

export function useImpersonatableCompanies() {
  const { user, isSuperAdmin, isSalesperson } = useAuth();
  return useQuery({
    queryKey: ["impersonatable-companies", user?.id, isSuperAdmin],
    enabled: !!user && isSalesperson,
    queryFn: async (): Promise<ImpersonatableCompany[]> => {
      let query = supabase.from("companies").select("id, name, status, cvr").order("name");
      if (!isSuperAdmin && user) query = query.eq("salesperson_user_id", user.id);
      const { data, error } = await query;
      if (error) throw error;
      return data ?? [];
    },
  });
}
